// extracted by mini-css-extract-plugin
module.exports = {"switch-input":"switch_switch-input__2vTLW","switch-label":"switch_switch-label__3h7oE","is-disabled":"switch_is-disabled___taN7"};